import axios from 'axios';
import config from './config';
import { store } from './store';
import { clearAuthData } from './store/authSlice';
import { clearAllUserData } from './store/userSlice';

// Create axios instance with baseURL from config
const axiosPublic = axios.create({
  baseURL: `${config.API_URL}`
});

const axiosPrivate = axios.create({
  baseURL: `${config.API_URL}`,

  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Функция для получения токена из localStorage
const getAuthToken = () => {
  // Сначала проверяем прямое сохранение токена
  const directToken = localStorage.getItem('auth_token');
  if (directToken) {
    return directToken;
  }

  // Фоллбэк на authState
  const authState = localStorage.getItem('authState');
  if (authState) {
    try {
      const parsed = JSON.parse(authState);
      return parsed.auth_token;
    } catch (e) {
      console.error('❌ [Interceptor] Ошибка парсинга authState:', e);
    }
  }

  // Последняя попытка - из Redux store
  const state = store.getState();
  return state.auth?.auth_token;
};

// Интерцептор для добавления токена в каждый запрос
axiosPrivate.interceptors.request.use(
  (config) => {
    // Логируем запрос если путь содержит undefined
    if (config.url && config.url.includes('undefined')) {
      console.error('🚨🚨🚨 REQUEST TO UNDEFINED URL 🚨🚨🚨');
      console.error('URL:', config.url);
      console.error('Stack trace:', new Error().stack);
    }

    // Не перезаписываем заголовок если он уже установлен (например, useAxiosPrivate)
    if (!config.headers.Authorization) {
      const token = getAuthToken();

      console.log('🔍 [axios.js Interceptor] Проверка токена для запроса:', config.url);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        console.log('✅ [axios.js Interceptor] Токен добавлен в заголовок');
        console.log('✅ [axios.js Interceptor] Token preview:', token.substring(0, 30) + '...');
      } else {
        console.error('❌ [axios.js Interceptor] Токен НЕ найден!');
        console.error('❌ [axios.js Interceptor] localStorage auth_token:', localStorage.getItem('auth_token'));
        console.error('❌ [axios.js Interceptor] localStorage authState:', localStorage.getItem('authState'));

        const state = store.getState();
        console.error('❌ [axios.js Interceptor] Redux auth state:', JSON.stringify(state.auth));
      }
    } else {
      console.log('ℹ️ [axios.js Interceptor] Заголовок Authorization уже установлен для:', config.url);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Глобальный интерцептор для обработки критических ошибок аутентификации
const handleAuthError = (error) => {
  // Обрабатываем 401 и 403 ошибки как критические ошибки аутентификации
  if (
    error.response?.status === 401 ||
    (error.response?.status === 401 && error.response?.data?.message === 'Invalid token')
  ) {
    store.dispatch(clearAllUserData());
    store.dispatch(clearAuthData());

    if (window.location.pathname !== config.ROUTES.HOME) {
      window.location.href = config.ROUTES.HOME;
    }
  }

  if (error.response?.status === 403) {
    if (window.location.pathname !== config.ROUTES.BAN) {
      window.location.href = config.ROUTES.BAN;
    }
  }

  return Promise.reject(error);
};

// Добавляем интерцептор к обоим экземплярам axios
axiosPublic.interceptors.response.use((response) => response, handleAuthError);

axiosPrivate.interceptors.response.use((response) => response, handleAuthError);

export { axiosPublic, axiosPrivate };
